"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenueTopView = void 0;
var tslib_1 = require("tslib");
var defaultAreaColor = "#FFFFFF";
var defaultAreaFilter = "";
var defaultOutline = "transparent";
var VenueTopView = (function () {
    function VenueTopView(input) {
        var _this = this;
        this.productId = null;
        this.salesChannelId = null;
        this.orgId = null;
        this.userId = null;
        this.container = null;
        this.isLoaded = false;
        this.areaElementDic = new Map();
        this.svgDocument = null;
        this.areas = [];
        this.disableInteraction = false;
        this.enableBookedAreas = false;
        this.productCategories = [];
        this.svgUrl = "";
        this.svgMode = "default";
        this.setAreaStyle = function (style) {
            if ("fill" in style) {
                _this.setAreaStyleFill(style.areaId, style.fill || null);
            }
            if ("filter" in style) {
                _this.setAreaStyleFilter(style.areaId, style.filter || null);
            }
            if ("outline" in style) {
                _this.setAreaStyleOutline(style.areaId, style.outline || null);
            }
            if ("customStroke" in style) {
                _this.setAreaStyleCustomStroke(style.areaId, style.customStroke || null);
            }
        };
        this.selectAreasByCategoryId = function (options) {
            _this.resetSelection();
            var entries = _this.productCategories.filter(function (entry) {
                if (options.areaIds) {
                    return (entry.categoryId === options.categoryId &&
                        options.areaIds.includes(entry.areaId));
                }
                else {
                    return entry.categoryId === options.categoryId;
                }
            });
            entries.forEach(function (entry) {
                if (!options.isMobile) {
                    _this.setAreaStyle({
                        areaId: entry.areaId,
                        fill: entry.categoryDefaultColor,
                        outline: options.isMobile ? "17px solid " + entry.categoryDefaultColor : defaultOutline,
                    });
                }
                else {
                    _this.setAreaStyle({
                        areaId: entry.areaId,
                        fill: entry.categoryDefaultColor,
                        customStroke: {
                            color: options.isMobile ? entry.categoryDefaultColor : "transparent",
                            opacity: "1",
                            width: "5",
                        },
                    });
                }
            });
        };
        this.resetSelection = function () {
            _this.areas.forEach(function (area) {
                _this.setAreaStyle({
                    areaId: area.areaId,
                    fill: null,
                    outline: null,
                });
            });
        };
        this.areaEventHandler = function (e) {
            var element = e.target;
            var areaId = _this.getAreaIdByHtmlElement(element);
            if (!areaId) {
                return;
            }
            if (_this.productId &&
                _this.productCategories.every(function (entry) { return entry.areaId !== areaId; }) &&
                !_this.enableBookedAreas) {
                return;
            }
            var data = _this.getAreaById(areaId);
            if (e.type === "click") {
                _this.onAreaClick(data);
            }
            if (e.type === "mouseover") {
                _this.onAreaMouseOver(data);
            }
            if (e.type === "mouseout") {
                _this.onAreaMouseOut(data);
            }
        };
        this.onLoaded = function (data) { };
        this.onAreaClick = function (data) { };
        this.onAreaMouseOver = function (data) { };
        this.onAreaMouseOut = function (data) { };
        if (!input.apiUrl) {
            throw new Error("apiUrl is required");
        }
        this.apiUrl = input.apiUrl;
        this.svgMode = input.svgMode;
        if (!input.venueId) {
            throw new Error("venueId is required");
        }
        this.venueId = input.venueId;
        this.svgUrl = input.svgUrl;
        if (!input.containerSelector) {
            throw new Error("containerSelector is required");
        }
        this.containerSelector = input.containerSelector;
    }
    VenueTopView.prototype.getTopViewSvgUrlByName = function (name) {
        if (this.svgMode === "dynamic") {
            if (!this.svgUrl) {
                throw 'svg dynamic mode requires svgUrl. please add stadium url';
            }
            return this.svgUrl;
        }
        var baseUrl = this.apiUrl.replace(/\/$/, "");
        return baseUrl + "/venue/" + this.venueId + "/image/" + name + ".svg";
    };
    VenueTopView.prototype.setupCategories = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.loadProductCategories()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    VenueTopView.prototype.loadProductCategories = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var apiUrl, userQuery, url, response, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        apiUrl = this.apiUrl.replace(/\/$/, "");
                        userQuery = this.userId ? "?userId=" + this.userId : "";
                        url = apiUrl + "/product/" + this.productId + "/salesChannel/" + this.salesChannelId + "/areas/orgId/" + this.orgId + userQuery;
                        return [4, fetch(url)];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) return [3, 3];
                        _a = this;
                        return [4, response.json()];
                    case 2:
                        _a.productCategories = _b.sent();
                        return [3, 4];
                    case 3: throw new Error("Cannot get categories");
                    case 4: return [2];
                }
            });
        });
    };
    VenueTopView.prototype.load = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var imageUrl, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!input.productId) return [3, 2];
                        this.orgId = input.orgId;
                        this.productId = input.productId;
                        if (!input.salesChannelId) {
                            throw new Error("SalesChannelId is required when productId is provided");
                        }
                        else {
                            this.salesChannelId = input.salesChannelId;
                        }
                        this.userId = input.userId;
                        return [4, this.setupCategories()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.isLoaded = false;
                        imageUrl = this.getTopViewSvgUrlByName(input.name);
                        this.container = document.querySelector(this.containerSelector);
                        this.disableInteraction =
                            input.options && "disableInteraction" in input.options
                                ? input.options.disableInteraction
                                : false;
                        this.enableBookedAreas =
                            input.options && "enableBookedAreas" in input.options
                                ? input.options.enableBookedAreas
                                : false;
                        return [4, this.loadSvg(imageUrl)];
                    case 3:
                        _a.sent();
                        this.isLoaded = true;
                        data = {
                            container: this.container,
                            svgDocument: this.svgDocument,
                            areas: this.areas,
                        };
                        this.onLoaded(data);
                        return [2];
                }
            });
        });
    };
    VenueTopView.prototype.destroy = function () { };
    VenueTopView.prototype.getSvgDocumentByUrl = function (url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, svgContent, parser, doc;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch(url)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("failed to fetch svg file");
                        }
                        return [4, response.text()];
                    case 2:
                        svgContent = _a.sent();
                        if (!svgContent) {
                            throw new Error("svg document empty");
                        }
                        parser = new DOMParser();
                        doc = parser.parseFromString(svgContent, "image/svg+xml");
                        return [2, doc.documentElement];
                }
            });
        });
    };
    VenueTopView.prototype.loadSvg = function (svgUrl) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var container, svg, _a, style, areaElements;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        container = this.container;
                        if (!container) {
                            throw new Error("failed to load svg");
                        }
                        container.innerHTML = "";
                        _a = this;
                        return [4, this.getSvgDocumentByUrl(svgUrl)];
                    case 1:
                        svg = (_a.svgDocument = _b.sent());
                        container.appendChild(svg);
                        style = document.createElement("style");
                        if (!this.disableInteraction) {
                            style.innerHTML = "\n          [data-area-id] { cursor: pointer; fill: " + defaultAreaColor + "\n          ";
                        }
                        else {
                            style.innerHTML = "\n          [data-area-id] { cursor: default; fill: " + defaultAreaColor + "\n          ";
                        }
                        svg.appendChild(style);
                        if (!this.disableInteraction) {
                            svg.addEventListener("mouseout", this.areaEventHandler, false);
                            svg.addEventListener("mouseover", this.areaEventHandler, false);
                            svg.addEventListener("click", this.areaEventHandler, false);
                        }
                        areaElements = svg.querySelectorAll("[data-area-id]");
                        areaElements.forEach(function (item) {
                            var areaElt = item;
                            var data = Object.assign({}, areaElt.dataset);
                            if ("areaId" in data && data.areaId) {
                                _this.areas.push(data);
                                var areaId = data.areaId;
                                if (_this.areaElementDic.has(areaId)) {
                                    var elements = _this.areaElementDic.get(areaId) || [];
                                    elements === null || elements === void 0 ? void 0 : elements.push(areaElt);
                                    _this.areaElementDic.set(areaId, elements);
                                }
                                else {
                                    _this.areaElementDic.set(areaId, [areaElt]);
                                }
                            }
                        });
                        return [2];
                }
            });
        });
    };
    VenueTopView.prototype.getAreaElements = function (areaId) {
        var areaElements = this.areaElementDic.get(areaId) || null;
        if (!areaElements) {
            throw new Error("Could not find area element with areaId=" + areaId);
        }
        return areaElements;
    };
    VenueTopView.prototype.setAreaStyleFill = function (areaId, fill) {
        var e_1, _a;
        var areaElements = this.getAreaElements(areaId);
        try {
            for (var areaElements_1 = tslib_1.__values(areaElements), areaElements_1_1 = areaElements_1.next(); !areaElements_1_1.done; areaElements_1_1 = areaElements_1.next()) {
                var areaElement = areaElements_1_1.value;
                areaElement.style.fill = fill || defaultAreaColor;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (areaElements_1_1 && !areaElements_1_1.done && (_a = areaElements_1.return)) _a.call(areaElements_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    VenueTopView.prototype.setAreaStyleFilter = function (areaId, filter) {
        var e_2, _a;
        var areaElements = this.getAreaElements(areaId);
        try {
            for (var areaElements_2 = tslib_1.__values(areaElements), areaElements_2_1 = areaElements_2.next(); !areaElements_2_1.done; areaElements_2_1 = areaElements_2.next()) {
                var areaElement = areaElements_2_1.value;
                areaElement.style.filter = filter || defaultAreaFilter;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (areaElements_2_1 && !areaElements_2_1.done && (_a = areaElements_2.return)) _a.call(areaElements_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    VenueTopView.prototype.setAreaStyleOutline = function (areaId, outline) {
        var e_3, _a;
        var areaElements = this.getAreaElements(areaId);
        try {
            for (var areaElements_3 = tslib_1.__values(areaElements), areaElements_3_1 = areaElements_3.next(); !areaElements_3_1.done; areaElements_3_1 = areaElements_3.next()) {
                var areaElement = areaElements_3_1.value;
                areaElement.style.outline = outline || defaultOutline;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (areaElements_3_1 && !areaElements_3_1.done && (_a = areaElements_3.return)) _a.call(areaElements_3);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    VenueTopView.prototype.setAreaStyleCustomStroke = function (areaId, stroke) {
        var e_4, _a;
        var _b;
        if (!this.svgDocument) {
            return;
        }
        var elementToRemove = (_b = this.svgDocument) === null || _b === void 0 ? void 0 : _b.getElementById("custom-stroke");
        if (elementToRemove) {
            this.svgDocument.removeChild(elementToRemove);
        }
        if (!stroke || !Object.keys(stroke).length) {
            return;
        }
        if (!stroke) {
            return;
        }
        var customStrokeGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
        customStrokeGroup.id = "custom-stroke";
        var _c = stroke.color, color = _c === void 0 ? "transparent" : _c, opacity = stroke.opacity, width = stroke.width;
        var areaElements = this.getAreaElements(areaId);
        try {
            for (var areaElements_4 = tslib_1.__values(areaElements), areaElements_4_1 = areaElements_4.next(); !areaElements_4_1.done; areaElements_4_1 = areaElements_4.next()) {
                var areaElement = areaElements_4_1.value;
                if (areaElement) {
                    areaElement.style.stroke = color;
                    areaElement.style.strokeOpacity = opacity;
                    areaElement.style.strokeWidth = width;
                    areaElement.style.fill = "transparent";
                }
                customStrokeGroup.appendChild(areaElement);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (areaElements_4_1 && !areaElements_4_1.done && (_a = areaElements_4.return)) _a.call(areaElements_4);
            }
            finally { if (e_4) throw e_4.error; }
        }
        this.svgDocument.appendChild(customStrokeGroup);
    };
    VenueTopView.prototype.getAreaById = function (areaId) {
        var area = this.areas.find(function (o) { return o.areaId === areaId; });
        if (!area) {
            throw new Error("could not find area with id : " + areaId);
        }
        return area;
    };
    VenueTopView.prototype.getAreaIdByHtmlElement = function (element) {
        return element ? element.getAttribute("data-area-id") : null;
    };
    return VenueTopView;
}());
exports.VenueTopView = VenueTopView;
//# sourceMappingURL=VenueTopView.js.map